import { ContentDto } from "./content"

export enum RequiredWidgetConfig {
  accessToken = "accessToken",
  refreshToken = "refreshToken",
  documotoDomain = "documotoDomain",
  locale = "locale",
  widgetType = "widgetType"
}

export enum MediaWidgetEntityTypes {
  media = "media",
  chapter = "chapter",
  page = "page"
}

export enum WidgetMediaTypes {
  book = 'book',
  document = 'document',
  external = 'external',
  illustration = 'illustration',
  image = 'image',
  microsite = 'microsite',
  video = 'video'
}

type WidgetTheme = {
  "brand_primary": string
}

export type WidgetConfig = Record<string, any> & {
  [RequiredWidgetConfig.accessToken]: string,
  [RequiredWidgetConfig.refreshToken]: string,
  [RequiredWidgetConfig.locale]: string,
  [RequiredWidgetConfig.documotoDomain]: string,
  enablePartTags?: boolean,
  enablePartComments?: boolean,
  enableCart?: boolean,
  bindToElementById?: string,
  browseFlowId?: string,
  theme: WidgetTheme,
  widgetType: WidgetTypes,
  mediaIdentifier?: string,
  productPageIdentifier?: string,
  targetUri?: string,
  showTableOfContents?: boolean,
  pageHashKey?: string,
  partNumber?: string,
  enableInformationLandingPage?: boolean,
  hostedDomain?: string|null,
  allowBookExport?: boolean,
  allowChapterExport?: boolean,
  allowPageExport?: boolean
}

export enum WidgetTypes {
  media = "media",
  library = "library",
  loading = "loading",
  page = "page",
  productPage = "productPage",
}

const lacksIdentifier = [ WidgetTypes.library, WidgetTypes.loading ]
type LacksIdentifier = (typeof lacksIdentifier)[number]

export function isWidgetLackingIdentifier(x: any): x is LacksIdentifier {
  return lacksIdentifier.includes(x)
}

export const WidgetTypesToIdentifiers = Object.freeze({
  [WidgetTypes.media]: "mediaIdentifier",
  [WidgetTypes.page]: "pageHashKey",
  [WidgetTypes.productPage]: "productPageIdentifier",
})

export type Breadcrumb = {
  created?: Date,
  id?: number,
  identifier?: string,
  name: string,
  type: string,
  updated?: Date
}

export enum LibraryWidgetOnlyPages {
  browse = 'browse',
  home = 'home',
  part = 'part',
  search = 'search'
}

export enum InfoPage {
  info = 'info',
  partInfo = 'part-info',
  pageInfo = 'page-info',
  productPageInfo = 'productpage-info'
}

export const LibraryWidgetPages = Object.freeze({
  ...LibraryWidgetOnlyPages,
  ...MediaWidgetEntityTypes,
  ...InfoPage
})

export enum ProductPageWidgetOnlyPages {
  productPage = 'productpage',
}

export enum WidgetErrorPages {
  contentError = 'content-error',
}

export const ProductPageWidgetPages = Object.freeze({
  ...ProductPageWidgetOnlyPages,
  ...MediaWidgetEntityTypes,
  ...InfoPage,
  ...WidgetErrorPages,
})

export enum WidgetRootBreadcrumbs {
  browse = 'browse',
  home = 'home',
  search = 'search'
}

export enum WidgetEvents {
  login = 'widgetLogin',
  error = 'widgetError'
}

export enum WidgetEventDetailTypes {
  Success = 'Success',
  Error = 'Error'
}

export enum WidgetEventSuccessMessages {
  login = 'Successful Documoto Widget Login'
}

export enum WidgetEventErrors {
  config = 'config',
  content_not_found = 'content_not_found',
  init = 'init',
  location = 'location',
  multiple_locations = 'multiple_locations'
}

export type TocFlatListItemDto = { item: ContentDto, chapters: Set<number>, index?: number }
